<template>
  <v-container fluid>
    <SidebarNavigation />
    <v-card>
      <v-tabs v-model="tab">
        <v-tabs-slider color="primary"></v-tabs-slider>

        <v-tab v-for="item in tabItems" :key="item">
          {{ item }}
        </v-tab>
      </v-tabs>
    </v-card>
    <v-card>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-row class="pt-3 pr-1 pl-1">
            <v-col cols="2.5">
              <v-autocomplete
                :items="divisionsOptions"
                @change="updateQuery('divisionId', $event)"
                item-text="mst_division_name"
                item-value="mst_division_id"
                label="Department"
                dense
                outlined
                v-model="selectedDivisionId"
              ></v-autocomplete>
            </v-col>
            <v-col cols="2.5">
              <v-autocomplete
                item-text="mst_position_name"
                item-value="mst_position_id"
                :items="positionOptions"
                v-model="selectedPositionId"
                @change="updateQuery('positionId', $event)"
                label="Jabatan"
                dense
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="2.5">
              <v-autocomplete
                item-text="name"
                item-value="id"
                :items="workflowOptions"
                v-model="selectedWorkflowId"
                @change="updateQuery('workflowId', $event)"
                label="Workflow"
                dense
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="2.5">
              <v-autocomplete
                item-text="mst_site_name"
                item-value="mst_site_id"
                :items="siteOptions"
                v-model="selectedSiteId"
                @change="updateQuery('siteId', $event)"
                label="Lokasi Kerja"
                dense
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="2">
              <v-text-field
                v-model="pagination.search"
                label="Search"
                append-icon="mdi-magnify"
                dense
                hide-details
                class="search-input"
                style="max-width: 250px"
                outlined
                @input="debouncedSearch"
              ></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-btn class="primary" @click="openDialog()"> Tambah </v-btn>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-data-table
                mobile-breakpoint="0"
                fixed-header
                dense
                class="elevation-5"
                :headers="tableHeaders"
                :items="workflowStepList"
                :items-per-page.sync="pagination.itemsPerPage"
                :page.sync="pagination.page"
                :sort-by="pagination.sortBy"
                :sort-desc="pagination.sortDesc"
                :server-items-length="totalWorkflowStep"
                item-key="id"
                @update:page="updateQuery('page', $event)"
                @update:items-per-page="updateQuery('itemsPerPage', $event)"
                @update:sort-by="updateQuery('sortBy', $event)"
                @update:sort-desc="updateQuery('sortDesc', $event)"
              >
                <template v-slot:body="{ items }">
                  <tbody>
                    <tr v-for="item in items" :key="item.id">
                      <td>{{ item.step_name }}</td>
                      <td>{{ item.sequence }}</td>
                      <td>{{ item.is_final_name }}</td>
                      <td>{{ item.approver_division_name }}</td>
                      <td>{{ item.approver_position_name }}</td>
                      <td>{{ item.approver_site_name }}</td>
                      <td>{{ item.approver_employee_name }}</td>
                      <td>
                        <div v-if="item.is_active">
                          {{ item.is_active_name }}
                        </div>
                        <div v-else :style="{ color: 'red' }">
                          {{ item.is_active_name }}
                        </div>
                      </td>

                      <td>
                        <v-btn icon @click="openDialogUpdate(item)">
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    <!-- create -->
    <v-dialog v-model="isDialogOpen" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Tambah workflow step</span>
        </v-card-title>
        <v-card-text>
          <v-form v-model="isFormValid">
            <v-autocomplete
              :items="divisionsOptionsApprover"
              item-text="mst_division_name"
              item-value="mst_division_id"
              label="Approver Department"
              dense
              outlined
              v-model="selectedDivisionIdApprover"
            ></v-autocomplete>

            <v-autocomplete
              item-text="mst_position_name"
              item-value="mst_position_id"
              :items="positionOptionsApprover"
              v-model="selectedPositionIdApprover"
              label="Approver Jabatan "
              dense
              outlined
            ></v-autocomplete>

            <v-autocomplete
              item-text="mst_site_name"
              item-value="mst_site_id"
              :items="siteOptionsApprover"
              v-model="selectedSiteIdApprover"
              label="Approver Lokasi Kerja"
              dense
              outlined
            ></v-autocomplete>

            <v-autocomplete
              item-text="mst_employee_name"
              item-value="mst_employee_id"
              :items="employeeOptionsApprover"
              v-model="selectedEmployeeIdApprover"
              label="Approver Employee"
              dense
              outlined
            ></v-autocomplete>

            <v-autocomplete
              item-text="name"
              item-value="name"
              :items="stepNameOptions"
              v-model="name"
              label="Step Name"
              dense
              outlined
            ></v-autocomplete>

            <v-text-field
              v-model="sequence"
              type="number"
              :rules="[
                (v) => !!v || 'Tidak boleh kosong',
                (v) => parseInt(v.replace(/\./g, '')) > 0 || 'Harus minimal 1',
              ]"
              label="Sequence"
              required
            ></v-text-field>
            <v-radio-group v-model="selectedIsFinal" label="Step Terakhir :">
              <v-radio label="No" value="0"></v-radio>
              <v-radio label="Yes" value="1"></v-radio>
            </v-radio-group>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="isDialogOpen = false">Cancel</v-btn>
          <v-btn color="primary" :disabled="!isFormValid" @click="submit"
            >Submit</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- update -->
    <v-dialog v-model="isDialogOpenEdit" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Ubah workflow step</span>
        </v-card-title>
        <v-card-text>
          <v-form v-model="isFormValidUpdate">
            <v-autocomplete
              :items="divisionsOptionsApprover"
              item-text="mst_division_name"
              item-value="mst_division_id"
              label="Approver Department"
              dense
              outlined
              v-model="selectedDivisionIdApprover"
            ></v-autocomplete>

            <v-autocomplete
              item-text="mst_position_name"
              item-value="mst_position_id"
              :items="positionOptionsApprover"
              v-model="selectedPositionIdApprover"
              label="Approver Jabatan "
              dense
              outlined
            ></v-autocomplete>

            <v-autocomplete
              item-text="mst_site_name"
              item-value="mst_site_id"
              :items="siteOptionsApprover"
              v-model="selectedSiteIdApprover"
              label="Approver Lokasi Kerja"
              dense
              outlined
            ></v-autocomplete>

            <v-autocomplete
              item-text="mst_employee_name"
              item-value="mst_employee_id"
              :items="employeeOptionsApprover"
              v-model="selectedEmployeeIdApprover"
              label="Approver Employee"
              dense
              outlined
            ></v-autocomplete>

            <v-autocomplete
              item-text="name"
              item-value="name"
              :items="stepNameOptions"
              v-model="name"
              label="Step Name"
              dense
              outlined
            ></v-autocomplete>

            <v-text-field
              v-model="sequence"
              type="number"
              :rules="[
                (v) => !!v || 'tidak boleh kosong',
                (v) => parseInt(v.replace(/\./g, '')) >= 0 || 'harus minimal 0',
              ]"
              label="Sequence"
              required
            ></v-text-field>

            <v-radio-group v-model="selectedIsFinal" label="Step Terakhir :">
              <v-radio label="No" value="0"></v-radio>
              <v-radio label="Yes" value="1"></v-radio>
            </v-radio-group>

            <v-radio-group v-model="selectedIsActive" label="Status :">
              <v-radio label="Active" value="1"></v-radio>
              <v-radio color="red" label="Inactive" value="0"></v-radio>
            </v-radio-group>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="isDialogOpenEdit = false"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            :disabled="!isFormValidUpdate"
            @click="submitUpdate"
            >Update</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <snackbarMessage />
  </v-container>
</template>

<script>
import api from "@/utils/api";
import SidebarNavigation from "@/components/SidebarNavigation.vue";
import snackbarMessage from "@/components/snackbarMessage.vue";
import store from "@/store";

export default {
  components: {
    SidebarNavigation,
    snackbarMessage,
  },
  data() {
    return {
      arrSequence: [],
      tabItems: ["Workflow Step"],
      isLoading: false,
      tab: 1,
      tableHeaders: [
        {
          text: "Nama Step",
          align: "center",
          value: "step_name",
          sortable: false,
        },
        {
          text: "Sequence",
          align: "center",
          value: "step_order",
          sortable: false,
        },
        {
          text: "Step Terakhir",
          align: "center",
          value: "is_final",
          sortable: false,
        },
        {
          text: "Approver Department",
          align: "center",
          value: "approver_divisi_name",
          sortable: false,
        },
        {
          text: "Approver Jabatan ",
          align: "center",
          value: "approver_position__name",
          sortable: false,
        },
        {
          text: "Approver Lokasi Kerja",
          align: "center",
          value: "Lokasi Kerja",
          sortable: false,
        },
        {
          text: "Approver Employee",
          align: "center",
          value: "employee",
          sortable: false,
        },
        { text: "Status", align: "center", value: "status", sortable: false },
        { text: "Aksi", align: "center", sortable: false },
      ],
      pagination: {
        page: 1,
        itemsPerPage: 10,
        sortBy: "id",
        sortDesc: false,
        search: null,
      },
      totalWorkflowStep: null,
      workflowStepList: [],
      workflowStep: { step_name: "" },
      isDialogOpen: false,
      isDialogOpenEdit: false,
      isDialogOpenDelete: false,
      isFormValid: false,
      isFormValidUpdate: false,
      name: null,
      workflowOptions: null,
      divisionsOptions: null,
      positionOptions: null,
      siteOptions: [],
      employeeOptions: null,
      selectedDivisionId: null,
      selectedPositionId: null,
      selectedWorkflowId: null,
      selectedSiteId: null,
      selectedEmployeeId: null,
      divisionsOptionsApprover: null,
      positionOptionsApprover: null,
      siteOptionsApprover: [],
      employeeOptionsApprover: null,
      stepNameOptions: [
        { name: "Approved Supervisor" },
        { name: "Approved Manager" },
        { name: "Approved Head of Accounting & Finance" },
        { name: "Approved Head of Commercial Logistics" },
      ],
      selectedDivisionIdApprover: null,
      selectedPositionIdApprover: null,
      selectedSiteIdApprover: null,
      selectedEmployeeIdApprover: null,
      selectedIsFinal: "0",
      selectedIsActive: "0",
      sequence: null,
    };
  },
  methods: {
    fetchWorkflow() {
      api
        .get("/workflows")
        .then(({ data }) => {
          this.workflowOptions = data.data.data;
        })
        .catch((error) => {
          console.error("Error fetching roles:", error);
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },
    fetchDivisions() {
      this.isDivisionsLoading = true;
      api
        .get("/divisions")
        .then(({ data }) => {
          this.divisionsOptions = data.data.data;
        })
        .catch((error) => {
          console.error("Error fetching division:", error);
        })
        .finally(() => {
          this.isLoading = false;
          this.isDivisionsLoading = false;
          store.dispatch("hideLoading");
        });
    },
    fetchDivisionsApprover() {
      this.isDivisionsLoading = true;
      api
        .get("/divisions")
        .then(({ data }) => {
          this.divisionsOptionsApprover = data.data.data;
          this.divisionsOptionsApprover.unshift({
            mst_division_id: 0,
            mst_division_name: "All",
          });
        })
        .catch((error) => {
          console.error("Error fetching division:", error);
        })
        .finally(() => {
          this.isLoading = false;
          this.isDivisionsLoading = false;
          store.dispatch("hideLoading");
        });
    },
    fetchPosition() {
      api
        .get(`/positions?divisionId=${this.selectedDivisionId}`)
        .then(({ data }) => {
          this.positionOptions = data.data.data;
        })
        .catch((error) => {
          console.error("Error fetching position:", error);
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },
    fetchPositionApprover() {
      api
        .get(`/positions?divisionId=${this.selectedDivisionIdApprover}`)
        .then(({ data }) => {
          this.positionOptionsApprover = data.data.data;
          this.positionOptionsApprover.unshift({
            mst_position_id: 0,
            mst_position_name: "All",
          });
        })
        .catch((error) => {
          console.error("Error fetching position:", error);
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },
    fetchSites() {
      api
        .get("/sites?corporateId=2")
        .then(({ data }) => {
          this.siteOptions = data.data.data;
        })
        .catch((error) => {
          console.error("Error fetching sites:", error);
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },
    fetchSitesApprover() {
      api
        .get("/sites?corporateId=2")
        .then(({ data }) => {
          this.siteOptionsApprover = data.data.data;
          this.siteOptionsApprover.unshift({
            mst_site_id: 0,
            mst_site_name: "All",
          });
          // console.log(this.siteOptions);
          // console.log(this.siteOptionsApprover);
        })
        .catch((error) => {
          console.error("Error fetching sites:", error);
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },
    fetchEmployeesApprover() {
      api
        .get(
          `/employees?divisionId=${this.selectedDivisionIdApprover}&positionId=${this.selectedPositionIdApprover}&siteId=${this.selectedSiteIdApprover}`,
        )
        .then(({ data }) => {
          this.employeeOptionsApprover = data.data.data;
          this.employeeOptionsApprover.unshift({
            mst_employee_id: 0,
            mst_employee_name: "All",
          });
        })
        .catch((error) => {
          console.error("Error fetching employee:", error);
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },

    fetchWorkflowSteps() {
      store.dispatch("showLoading");
      const query = this.$route.query;
      const params = {
        page: parseInt(query.page) || this.pagination.page,
        limit: parseInt(query.itemsPerPage) || this.pagination.itemsPerPage,
        search: query.search || this.pagination.search,
        sortBy: query.sortBy || this.pagination.sortBy || "name",
        sortDesc: query.sortDesc || this.pagination.sortDesc || false,
        startDate: query.startDate || this.startDate,
        endDate: query.endDate || this.endDate,
        workflowId: query.workflowId || this.workflowId || 0,
        divisionId: query.divisionId || this.divisionId || 0,
        positionId: query.positionId || this.positionId || 0,
        siteId: query.siteId || this.siteId || 0,
      };

      api
        .get("/workflow-steps", { params })
        .then(({ data }) => {
          this.workflowStepList = data.data.data;
          this.totalWorkflowStep = data.data.total;
        })
        .catch((error) => {
          console.error("Error fetching suggestion:", error);
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },
    openDialog() {
      if (!this.selectedDivisionId) {
        store.dispatch("triggerSnackbar", {
          message: "Pilih divisi terlebih dahulu !",
          isSuccess: false,
        });
        return;
      } else if (!this.selectedPositionId) {
        store.dispatch("triggerSnackbar", {
          message: "Pilih posisi terlebih dahulu !",
          isSuccess: false,
        });
        return;
      } else if (!this.selectedWorkflowId) {
        store.dispatch("triggerSnackbar", {
          message: "Pilih workflow terlebih dahulu !",
          isSuccess: false,
        });
        return;
      }
      this.fetchDivisionsApprover();
      this.fetchSitesApprover();
      this.selectedDivisionIdApprover = null;
      this.selectedPositionIdApprover = null;
      this.selectedSiteIdApprover = null;
      this.name = null;
      this.arrSequence = [];
      console.log(this.workflowStepList);
      for (let i = 0; i < this.workflowStepList.length; i++) {
        this.arrSequence.push(this.workflowStepList[i].sequence);
      }
      this.sequence = Math.max(...this.arrSequence) + 1;

      this.isDialogOpen = true;
    },
    openDialogUpdate(params = null) {
      console.log(params);
      this.fetchDivisionsApprover();
      this.fetchSitesApprover();
      this.workflowStep = params;
      this.name = params.step_name;
      this.selectedDivisionIdApprover = parseInt(params.approver_division_id);
      this.selectedPositionIdApprover = parseInt(params.approver_position_id);
      this.selectedSiteIdApprover = parseInt(params.approver_site_id);
      this.selectedEmployeeIdApprover = parseInt(params.approver_employee_id);
      this.sequence = params.sequence;
      this.selectedIsFinal = params.is_final.toString();
      this.selectedIsActive = params.is_active.toString();
      this.isDialogOpenEdit = true;
    },
    openDialogDelete(params) {
      this.workflowStep = params;
      this.isDialogOpenDelete = true;
    },
    submit() {
      store.dispatch("showLoading");
      const payload = {
        name: this.name,
        division_id: this.selectedDivisionId,
        position_id: this.selectedPositionId,
        workflow_id: this.selectedWorkflowId,
        site_id: this.selectedSiteId,
        approver_division_id: this.selectedDivisionIdApprover,
        approver_position_id: this.selectedPositionIdApprover,
        approver_site_id: this.selectedSiteIdApprover,
        approver_employee_id: this.selectedEmployeeIdApprover,
        sequence: this.sequence,
        is_final: this.selectedIsFinal,
      };
      api
        .post("/workflow-steps", payload)
        .then((response) => {
          const message = response.data.message;
          this.fetchWorkflowSteps();
          this.isDialogOpen = false;
          store.dispatch("triggerSnackbar", { message, isSuccess: true });
        })
        .catch((error) => {
          let message = "Failed to save workflowstep!";
          if (error.response) {
            message = error.response.data.message || message;
          } else {
            message = error.message || message;
          }
          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },
    submitUpdate() {
      store.dispatch("showLoading");
      const payload = {
        id: this.workflowStep.id,
        name: this.name,
        division_id: this.selectedDivisionId,
        position_id: this.selectedPositionId,
        workflow_id: this.selectedWorkflowId,
        site_id: this.selectedSiteId,
        approver_division_id: this.selectedDivisionIdApprover,
        approver_position_id: this.selectedPositionIdApprover,
        approver_site_id: this.selectedSiteIdApprover,
        approver_employee_id: this.selectedEmployeeIdApprover,
        is_final: this.selectedIsFinal,
        is_active: this.selectedIsActive,
        sequence: this.sequence,
      };
      api
        .post("/workflow-steps/update", payload)
        .then((response) => {
          const message = response.data.message;
          this.fetchWorkflowSteps();
          this.isDialogOpenEdit = false;
          store.dispatch("triggerSnackbar", { message, isSuccess: true });
        })
        .catch((error) => {
          let message = "Failed to save workflowstep!";
          if (error.response) {
            message = error.response.data.message || message;
          } else {
            message = error.message || message;
          }
          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },
    submitDelete() {
      store.dispatch("showLoading");
      api
        .post("/workflow-steps/delete", { id: this.workflowStep.id })
        .then((response) => {
          const message =
            response.data.message || "Employee deleted successfully!";
          this.fetchWorkflowSteps();
          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: true,
          });
          this.isDialogOpenDelete = false;
        })
        .catch((error) => {
          console.error("Error deleting workflow step:", error);
          let message = "Failed to delete workflow step.";

          if (error.response) {
            message = error.response.data.message || message;
          } else {
            message = error.message || message;
          }
          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },
    debouncedSearch() {
      this.updateQuery("search", this.pagination.search);
    },
    updatePagination(query) {
      this.pagination.page = parseInt(query.page) || 1;
      this.pagination.itemsPerPage = parseInt(query.itemsPerPage) || 10;
      this.pagination.sortBy = query.sortBy || "id";
      this.pagination.sortDesc = query.sortDesc === "true" ? true : false;
      this.pagination.search = query.search || this.pagination.search || "";
      this.selectedDivisionId =
        parseInt(query.divisionId) || this.selectedDivisionId || 0;
      this.selectedPositionId =
        parseInt(query.positionId) || this.selectedPositionId || 0;
      this.selectedWorkflowId =
        parseInt(query.workflowId) || this.selectedWorkflowId || 0;
      this.selectedSiteId = parseInt(query.siteId) || this.selectedSiteId || 0;
    },
    updateQuery(key, value) {
      if (this.$route.query[key] !== value) {
        this.$router
          .push({
            query: {
              ...this.$route.query,
              [key]: value, // Mengupdate parameter query dengan key dan value
            },
          })
          .catch((err) => {
            // Handle error jika ada (contohnya, karena navigasi yang redundant)
            if (err.name !== "NavigationDuplicated") {
              console.error(err);
            }
          });
      }
      this.updatePagination(this.$route.query);
    },
  },
  mounted() {
    store.commit("setTitle", "Workflow Steps");
    this.fetchDivisions();
    this.fetchWorkflow();
    this.fetchSites();
    this.fetchWorkflowSteps();
    this.updatePagination(this.$route.query);
  },
  watch: {
    pagination: {
      handler: "fetchWorkflowSteps",
      deep: true, // Memastikan perubahan dalam objek pagination terdeteksi
    },
    selectedDivisionId() {
      this.fetchPosition();
      this.fetchWorkflowSteps();
    },
    selectedDivisionIdApprover() {
      this.fetchPositionApprover();
      this.fetchEmployeesApprover();
    },
    selectedPositionId() {
      this.fetchWorkflowSteps();
    },
    selectedPositionIdApprover() {
      this.fetchEmployeesApprover();
    },
    selectedWorkflowId() {
      this.fetchWorkflowSteps();
    },
    selectedSiteIdApprover() {
      this.fetchEmployeesApprover();
    },
    selectedSiteId() {
      this.fetchWorkflowSteps();
    },
  },
};
</script>
<style scoped>
.v-data-table td:nth-child(2),
td:nth-child(3),
td:nth-child(8) {
  text-align: center;
}
</style>
